import AoneService from "../axiosbase";
//Localizations
//get localizations
export const getLocalization = async (params) => {
    try  {
        return await AoneService.get(`settings/api/v1/localizations${params}`)
    } catch (error) {
        return error;
    }
}
//post localaizations
export const postLocalization = async (params,data) => {
    try {
      return await AoneService.post(`settings/api/v1/localizations?component=${params}`,data);
    } catch (error) {
      return error;
    }
  };

  //edit localization
  export const editLocalization = async (params,data) => {
   try {
     return await AoneService.put(`settings/api/v1/localizations?component=${params}`,data);
   } catch (error) {
     return error;
   }
 };

//get localizations by id
export const getLocalizationbyId = async (params) => {
    try {
      return await AoneService.get(`settings/api/v1/localizations/${params}`);
    } catch (error) {
      return error;
    }
  };
//get localizations by language and component
export const getLocalizationbyComponent = async (params,params2) => {
   try {
     return await AoneService.post(`settings/api/v1/localizations/${params}?component=${params2}`);
   } catch (error) {
     return error;
   }
 };
//localization template
export const localizationTemplate = async () => {
    try {
      return await AoneService.get(
        `settings/api/v1/localizations/template/download`,
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      return error;
    }
  };

//localaization import
export const importLocalization = async (params,data) => {
    try {
      return await AoneService.post(`settings/api/v1/localizations/upload?component=${params}`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      return error;
    }
  };

//localization export
export const exportLocalization = async (params) => {
   try {
     return await AoneService.get(`settings/api/v1/localizations/download?component=${params}`, {
       responseType: "blob",
     });
   } catch (error) {
     return error;
   }
 };

 //delete localization
 export const deleteLocalization = async (params) => {
   try {
     return await AoneService.delete(`settings/api/v1/localizations/${params}`);
   } catch (error) {
     return error;
   }
 }

 //language
 export const getLanguage = async () => {
  try  {
      return await AoneService.get(`settings/api/v1/languages`)
  } catch (error) {
      return error;
  }
}

//settings api's
//get systems
export const getSettings = async (params) => {
  try  {
      return await AoneService.get(`settings/api/v1/settings${params}`)
  } catch (error) {
      return error;
  }
}
//post systems
export const postSettings = async (params,data) => {
  try {
    return await AoneService.post(`settings/api/v1/settings?component=${params}`,data);
  } catch (error) {
    return error;
  }
};

//edit systems
export const editSettings = async (data) => {
 try {
   return await AoneService.put(`settings/api/v1/settings`,data);
 } catch (error) {
   return error;
 }
};

//get systems by id
export const getSettingsbyId = async (params) => {
  try {
    return await AoneService.get(`settings/api/v1/settings/${params}`);
  } catch (error) {
    return error;
  }
};
//get systems by language and component
export const getSettingsbyComponent = async (params,params2) => {
 try {
   return await AoneService.post(`settings/api/v1/settings/${params}?component=${params2}`);
 } catch (error) {
   return error;
 }
};
//systems template
export const settingsTemplate = async () => {
  try {
    return await AoneService.get(
      `settings/api/v1/settings/template/download`,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//systems import
export const importSettings = async (params,data) => {
  try {
    return await AoneService.post(`settings/api/v1/settings/upload?component=${params}`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};

//systems export
export const exportSettings = async (params) => {
 try {
   return await AoneService.get(`settings/api/v1/settings/download?component=${params}`, {
     responseType: "blob",
   });
 } catch (error) {
   return error;
 }
};

//delete systems
export const deleteSettings = async (params) => {
 try {
   return await AoneService.delete(`settings/api/v1/settings/${params}`);
 } catch (error) {
   return error;
 }
}

//Directory
//get directory
export const getDirectory = async () => {
  try  {
      return await AoneService.get(`settings/api/v1/resource/directory`)
  } catch (error) {
      return error;
  }
}
//post directory
export const postDirectory = async (data) => {
  try {
    return await AoneService.post(`settings/api/v1/resource/directory`,data);
  } catch (error) {
    return error;
  }
};
//delete resources
export const deleteResources = async (params) => {
  try {
    return await AoneService.delete(`settings/api/v1/resource/files/${params}`);
  } catch (error) {
    return error;
  }
};
//google files
//download files
export const downloadFiles = async (params) => {
  try {
    return await AoneService.get(`settings/api/v1/resource/files/${params}/download`,
    {
     responseType: "blob"
    }
  );
  } catch (error) {
    return error;
  }
};
//upload files
export const uploadFiles = async (params,data) => {
  try {
    return await AoneService.post(`settings/api/v1/resource/files/${params}`, data, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error) {
    return error;
  }
};
//get report question id
export const getReportQuestionId = async (params) => {
  try {
    return await AoneService.get(`settings/api/v1/reports/questions/${params}`);
  } catch (error) {
    return error;
  }
};
//get reports
export const getReports = async (params) => {
  try {
    return await AoneService.get(`settings/api/v1/reports/`);
  } catch (error) {
    return error;
  }
};

export const getDashboardQuestionId = async (params) => {
  try {
    return await AoneService.get(`settings/api/v1/dashboards/dashboard/${params}`);
  } catch (error) {
    return error;
  }
};
//get reports
export const getDashboard = async (params) => {
  try {
    return await AoneService.get(`settings/api/v1/dashboards/`);
  } catch (error) {
    return error;
  }
};

